// Espelha OrigemVendaEnum no backend. Nao tem tabela: e derivado de
// venda.isOrigemOrcamento (false = criado diretamente).
// Aplica-se somente aos Pedidos de Venda.
export enum OrigemVendaEnum {
    Todos = 1,
    OriginadoDeOrcamento = 2,
    CriadoDiretamente = 3,
}
